var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "user-guidance" },
    [
      _c("tooltipLine", {
        attrs: {
          visible: !(
            _vm.$store.state.user.hasBindData &&
            _vm.$store.state.user.hasBindData.isExistShop
          ),
          content: _vm.$t("system::common::no_authority_tooltip"),
        },
      }),
      !_vm.guidanced &&
      _vm.$store.state.user.userId == _vm.$store.state.user.merchantId
        ? [
            _c(
              "div",
              { staticClass: "operation" },
              [
                _c("span", { staticClass: "text" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("user-guidance::guide::title", {
                          step: _vm.elTabPaneList.filter(function (item) {
                            return !item.complete
                          }).length,
                        })
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "small" },
                    on: { click: _vm.handleCloseGuidance },
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("user-guidance::guide::close")) + " "
                    ),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: { value: _vm.tabName, "tab-position": "left" },
                    on: { "tab-click": _vm.handleTabClick },
                  },
                  _vm._l(_vm.elTabPaneList, function (item) {
                    return _c(
                      "el-tab-pane",
                      {
                        key: item.index,
                        staticStyle: {
                          "text-align": "left",
                          background: "white",
                          width: "100%",
                        },
                        attrs: {
                          name: item.name,
                          disabled: !(
                            _vm.$store.state.user.hasBindData &&
                            _vm.$store.state.user.hasBindData.isExistShop
                          ),
                        },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "box",
                            class: { choose: item.index == _vm.chooseIndex },
                            attrs: { slot: "label" },
                            slot: "label",
                          },
                          [
                            item.complete
                              ? _c("i", { staticClass: "el-icon-success" })
                              : _c("span", { staticClass: "yuan" }, [
                                  _vm._v(" " + _vm._s(item.index) + " "),
                                ]),
                            _c("span", { staticClass: "title" }, [
                              _vm._v(_vm._s(item.title)),
                            ]),
                          ]
                        ),
                        _c("div", { staticClass: "content-box" }, [
                          _c(
                            "div",
                            { staticClass: "content-wrap" },
                            [
                              _c("div", { staticClass: "text" }, [
                                _vm._v(" " + _vm._s(item.text) + " "),
                              ]),
                              _c("div", { staticClass: "tip" }, [
                                _vm._v(" " + _vm._s(item.tip) + " "),
                              ]),
                              _vm._l(item.buttons, function (btn, index) {
                                return _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "buried",
                                        rawName: "v-buried",
                                        value: {
                                          event: "GuideButtonClick",
                                          buttonName: btn.buttonName,
                                        },
                                        expression:
                                          "{ event: 'GuideButtonClick', buttonName: btn.buttonName }",
                                      },
                                      {
                                        name: "auth",
                                        rawName: "v-auth",
                                        value: btn.auth,
                                        expression: "btn.auth",
                                      },
                                    ],
                                    key: index,
                                    staticClass: "btn",
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleBtnClick(btn.click)
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(btn.btnText) + " ")]
                                )
                              }),
                            ],
                            2
                          ),
                          _c("img", { attrs: { src: item.imgUrl } }),
                        ]),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : _c(
            "div",
            { staticClass: "guidenced-content" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 24, lg: 17 } },
                    [
                      _c("el-card", { staticClass: "analysis" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("user-guidance::data::sales_title"))
                          ),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "list",
                            staticStyle: { padding: "24px 0 0 24px" },
                          },
                          _vm._l(_vm.analysisList, function (item) {
                            return _c(
                              "div",
                              { key: item.text, staticClass: "box box-border" },
                              [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$dataCheck(item.text)) +
                                      " "
                                  ),
                                  item.currency
                                    ? _c("span", [
                                        _vm._v(
                                          "(" + _vm._s(item.currency) + ")"
                                        ),
                                      ])
                                    : _vm._e(),
                                ]),
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom-start",
                                      trigger: "hover",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "card-content__popover" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-content__contentleft",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card-content__top",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "system::common::current_num"
                                                    )
                                                  ) +
                                                    ": " +
                                                    _vm._s(item.number)
                                                ),
                                              ]
                                            ),
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "system::common::statistics_days"
                                                  )
                                                ) +
                                                  ": " +
                                                  _vm._s(item.statisticsDays)
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c("div", [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "card-content__top",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "system::common::last_num"
                                                  )
                                                ) +
                                                  ": " +
                                                  _vm._s(item.lastNumber)
                                              ),
                                            ]
                                          ),
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "system::common::compare_result"
                                                  )
                                                ) +
                                                ": "
                                            ),
                                            item.rate
                                              ? _c(
                                                  "span",
                                                  {
                                                    style:
                                                      item.rate < 0
                                                        ? "color: #16C97B"
                                                        : "color: #F23E55",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            item.rate
                                                          )
                                                        ) +
                                                        "% "
                                                    ),
                                                  ]
                                                )
                                              : _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$dataCheck(item.rate)
                                                    ) + "%"
                                                  ),
                                                ]),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "number font-manrope",
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$dataCheck(item.number, 0)
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass: "rate",
                                    style: item.rate < 0 ? "color:green" : "",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "font-manrope" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$dataCheck(item.rate))
                                        ),
                                      ]
                                    ),
                                    _vm._v(" % "),
                                    item.rate < 0
                                      ? _c("i", {
                                          staticClass:
                                            "iconfont iconChevron-Top",
                                          staticStyle: {
                                            transform: "rotate(180deg)",
                                          },
                                        })
                                      : _c("i", {
                                          staticClass:
                                            "iconfont iconChevron-Top",
                                        }),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          0
                        ),
                      ]),
                      _c("el-card", { staticClass: "analysis" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("user-guidance::data::ad_title")) +
                              " "
                          ),
                          !(
                            _vm.$store.state.user.hasBindData &&
                            _vm.$store.state.user.hasBindData.isExistAds
                          )
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "#8a909d",
                                        "margin-right": "8px",
                                        "margin-left": "16px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t(
                                              "user-guidance::data::ad_tip"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { padding: "0" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          _vm.faceBookModalShow = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("ad-analysis::auth_fb")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: { padding: "0" },
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          _vm.googleModalShow = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("ad-analysis::auth_google")
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                        _c(
                          "div",
                          { staticClass: "list" },
                          _vm._l(_vm.adverList, function (item) {
                            return _c(
                              "div",
                              { key: item.text, staticClass: "box-wrap" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "box" },
                                  [
                                    _c("div", { staticClass: "text" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$dataCheck(item.text)) +
                                          " "
                                      ),
                                      item.currency
                                        ? _c("span", [
                                            _vm._v(
                                              "(" + _vm._s(item.currency) + ")"
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]),
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "bottom-start",
                                          trigger: "hover",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-content__popover",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "card-content__contentleft",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-content__top",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "system::common::current_num"
                                                        )
                                                      ) +
                                                        ": " +
                                                        _vm._s(item.number)
                                                    ),
                                                  ]
                                                ),
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "system::common::statistics_days"
                                                      )
                                                    ) +
                                                      ": " +
                                                      _vm._s(
                                                        item.statisticsDays
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("div", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "card-content__top",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "system::common::last_num"
                                                      )
                                                    ) +
                                                      ": " +
                                                      _vm._s(item.lastNumber)
                                                  ),
                                                ]
                                              ),
                                              _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "system::common::compare_result"
                                                      )
                                                    ) +
                                                    ": "
                                                ),
                                                item.rate
                                                  ? _c(
                                                      "span",
                                                      {
                                                        style:
                                                          item.rate < 0
                                                            ? "color: #16C97B"
                                                            : "color: #F23E55",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$dataCheck(
                                                                item.rate
                                                              )
                                                            ) +
                                                            "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$dataCheck(
                                                            item.rate
                                                          )
                                                        ) + "%"
                                                      ),
                                                    ]),
                                              ]),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "number font-manrope",
                                            attrs: { slot: "reference" },
                                            slot: "reference",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$dataCheck(item.number, 0)
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "rate",
                                        style:
                                          item.rate < 0 ? "color:green" : "",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "font-manrope" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$dataCheck(item.rate))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" % "),
                                        item.rate < 0
                                          ? _c("i", {
                                              staticClass:
                                                "iconfont iconChevron-Top",
                                              staticStyle: {
                                                transform: "rotate(180deg)",
                                              },
                                            })
                                          : _c("i", {
                                              staticClass:
                                                "iconfont iconChevron-Top",
                                            }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "box-img" }, [
                                  _c("img", { attrs: { src: item.img } }),
                                ]),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 24, lg: 7 } },
                    [
                      _c("el-card", { staticClass: "action" }, [
                        _c("div", { staticClass: "title" }, [
                          _c("img", {
                            staticClass: "calendar",
                            attrs: {
                              src: require("@/assets/images/userGuidance/calendar.png"),
                              alt: "",
                            },
                          }),
                          _c("div", [
                            _c("span", { staticClass: "nowDay" }, [
                              _vm._v(_vm._s(_vm.nowDay)),
                            ]),
                            _c("p", { staticClass: "date" }, [
                              _vm._v(_vm._s(_vm.nowDate)),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "list" },
                          [
                            _c(
                              "el-row",
                              [
                                _vm._l(_vm.actionList, function (item) {
                                  return [
                                    !item.auth || _vm.authPromise(item.auth)
                                      ? _c(
                                          "el-col",
                                          {
                                            key: item.index,
                                            staticClass: "box",
                                            attrs: { span: 8 },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "action-wrap",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleActionClick(
                                                      item.index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "img-wrap",
                                                    style: {
                                                      background: item.bgColor,
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: item.url,
                                                        alt: "",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "text" },
                                                  [_vm._v(_vm._s(item.text))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24, xl: 12, lg: 12, md: 24 } },
                    [
                      _c(
                        "el-card",
                        { staticClass: "send-order" },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "96px" },
                                  attrs: {
                                    size: "small",
                                    type:
                                      _vm.tableParams.type === 0
                                        ? "primary"
                                        : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTableType(0)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "user-guidance::data::table_热销榜"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { width: "96px" },
                                  attrs: {
                                    size: "small",
                                    type:
                                      _vm.tableParams.type === 1
                                        ? "primary"
                                        : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeTableType(1)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "user-guidance::data::table_退款榜"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            {
                              staticStyle: {
                                margin: "16px 0px",
                                display: "flex",
                                "align-items": "center",
                                "font-size": "12px",
                              },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: {
                                        width: "150px",
                                        "margin-right": "16px",
                                      },
                                      attrs: {
                                        popperAppendToBody: false,
                                        placeholder: _vm.$t(
                                          "system::common::select_placeholder"
                                        ),
                                      },
                                      on: { change: _vm.getList },
                                      model: {
                                        value: _vm.tableParams.shopId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.tableParams,
                                            "shopId",
                                            $$v
                                          )
                                        },
                                        expression: "tableParams.shopId",
                                      },
                                    },
                                    _vm._l(_vm.selectShopList, function (item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                  _c("el-date-picker", {
                                    staticStyle: { width: "300px" },
                                    attrs: {
                                      clearable: false,
                                      type: "daterange",
                                      align: "right",
                                      "unlink-panels": "",
                                      "range-separator": "~",
                                      "start-placeholder": "开始日期",
                                      "end-placeholder": "结束日期",
                                      "picker-options": _vm.pickerOptions,
                                    },
                                    on: { change: _vm.changeTableDate },
                                    model: {
                                      value: _vm.selectTableDate,
                                      callback: function ($$v) {
                                        _vm.selectTableDate = $$v
                                      },
                                      expression: "selectTableDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticStyle: { "min-height": "260px" } },
                            [
                              _vm.tableParams.type === 0
                                ? _c("z-table", {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.loading,
                                        expression: "loading",
                                      },
                                    ],
                                    ref: "table",
                                    attrs: {
                                      columns: _vm.salesColumns,
                                      customDefault: { height: "325px" },
                                      data: _vm.dataList,
                                      height: "325px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "index",
                                          fn: function (scope) {
                                            return [
                                              scope.$index > 2
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ])
                                                : _c("img", {
                                                    staticStyle: {
                                                      height: "24px",
                                                      width: "24px",
                                                    },
                                                    attrs: {
                                                      src: _vm.rankImg[
                                                        scope.$index
                                                      ],
                                                    },
                                                  }),
                                            ]
                                          },
                                        },
                                        {
                                          key: "spuImage",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("el-image", {
                                                staticClass: "goods-image",
                                                attrs: { src: row.spuImage },
                                              }),
                                            ]
                                          },
                                        },
                                        {
                                          key: "spuId",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(row.spuId)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "saleAccount",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.saleAccount
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "saleAmount",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.saleAmount
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "refundAccount",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.refundAccount
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "availableInventory",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.availableInventory
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4076372042
                                    ),
                                  })
                                : _vm._e(),
                              _vm.tableParams.type === 1
                                ? _c("z-table", {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.loading,
                                        expression: "loading",
                                      },
                                    ],
                                    ref: "table",
                                    attrs: {
                                      columns: _vm.refundColumns,
                                      customDefault: { height: "325px" },
                                      data: _vm.dataList,
                                      height: "325px",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "index",
                                          fn: function (scope) {
                                            return [
                                              scope.$index > 2
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(scope.$index + 1)
                                                    ),
                                                  ])
                                                : _c("img", {
                                                    staticStyle: {
                                                      height: "24px",
                                                      width: "24px",
                                                    },
                                                    attrs: {
                                                      src: _vm.rankImg[
                                                        scope.$index
                                                      ],
                                                    },
                                                  }),
                                            ]
                                          },
                                        },
                                        {
                                          key: "imageUrl",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _c("el-image", {
                                                staticClass: "goods-image",
                                                attrs: { src: row.imageUrl },
                                              }),
                                            ]
                                          },
                                        },
                                        {
                                          key: "spuId",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(row.spuId)
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "saleAccount",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.saleAccount
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "refundAmount",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.refundAmount
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "refundAccount",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.refundAccount
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "refundRate",
                                          fn: function (ref) {
                                            var row = ref.row
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$dataCheck(
                                                      row.refundRate
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1236180714
                                    ),
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24, xl: 12, lg: 12, md: 24 } },
                    [
                      _c(
                        "el-card",
                        { staticClass: "sale-analysis" },
                        [
                          _c("p", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("user-guidance::data::analysis_title")
                              )
                            ),
                          ]),
                          _c(
                            "el-row",
                            {
                              staticStyle: { padding: "0 30px" },
                              attrs: { gutter: 12 },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c(
                                    "el-row",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "8px",
                                        display: "flex",
                                        "align-items": "center",
                                        "font-size": "12px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 24 } },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "150px",
                                                "margin-right": "16px",
                                              },
                                              attrs: {
                                                popperAppendToBody: false,
                                                placeholder: _vm.$t(
                                                  "system::common::select_placeholder"
                                                ),
                                              },
                                              on: {
                                                change: _vm.handlerSelectChange,
                                              },
                                              model: {
                                                value: _vm.selectedShop,
                                                callback: function ($$v) {
                                                  _vm.selectedShop = $$v
                                                },
                                                expression: "selectedShop",
                                              },
                                            },
                                            _vm._l(
                                              _vm.selectShopList,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c("el-date-picker", {
                                            staticStyle: { width: "300px" },
                                            attrs: {
                                              clearable: false,
                                              type: "daterange",
                                              align: "right",
                                              "unlink-panels": "",
                                              "range-separator": "~",
                                              "start-placeholder": "开始日期",
                                              "end-placeholder": "结束日期",
                                              "picker-options":
                                                _vm.pickerOptions,
                                            },
                                            on: {
                                              change: _vm.handlerDateChange,
                                            },
                                            model: {
                                              value: _vm.selectDate,
                                              callback: function ($$v) {
                                                _vm.selectDate = $$v
                                              },
                                              expression: "selectDate",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            {
                              staticStyle: { padding: "0 30px" },
                              attrs: { gutter: 20 },
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 24 } },
                                [
                                  _c("reportCard", {
                                    directives: [
                                      {
                                        name: "loading",
                                        rawName: "v-loading",
                                        value: _vm.reportCardLoading,
                                        expression: "reportCardLoading",
                                      },
                                    ],
                                    attrs: { config: _vm.saleTrendData },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
      _c("closeModal", {
        ref: "closeModal",
        on: { closeGuidance: _vm.closeGuidance },
      }),
      _c("createShopModal", {
        ref: "createShopModal",
        attrs: { isDetail: false, isNew: true },
      }),
      _c("faceBookModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.onSave },
        model: {
          value: _vm.faceBookModalShow,
          callback: function ($$v) {
            _vm.faceBookModalShow = $$v
          },
          expression: "faceBookModalShow",
        },
      }),
      _c("googleModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.onSave },
        model: {
          value: _vm.googleModalShow,
          callback: function ($$v) {
            _vm.googleModalShow = $$v
          },
          expression: "googleModalShow",
        },
      }),
      _c("emailModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.onSave },
        model: {
          value: _vm.drawerVisable,
          callback: function ($$v) {
            _vm.drawerVisable = $$v
          },
          expression: "drawerVisable",
        },
      }),
      _c("paySettingModal", {
        attrs: { dialogType: "add", shopList: _vm.shopList },
        on: { closeDialog: _vm.onSave },
        model: {
          value: _vm.payDialogVisible,
          callback: function ($$v) {
            _vm.payDialogVisible = $$v
          },
          expression: "payDialogVisible",
        },
      }),
      _c("sendModal", {
        on: { closeDialog: _vm.onSave },
        model: {
          value: _vm.sendModalShow,
          callback: function ($$v) {
            _vm.sendModalShow = $$v
          },
          expression: "sendModalShow",
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }